import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  return <header className="relative min-h-screen flex flex-col items-center justify-center pt-20 pb-16 overflow-hidden bg-primary" data-id="element-97">
      {/* Background Gradients */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-98">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-accent-blue/10 rounded-full blur-[100px]" data-id="element-99" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-accent-blue/5 rounded-full blur-[100px]" data-id="element-100" />
      </div>

      <div className="container mx-auto px-4 z-10 max-w-5xl text-center" data-id="element-101">
        {/* Badge */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="inline-block mb-6 px-4 py-1.5 rounded-full border border-accent-blue/30 bg-accent-blue/10 text-accent-blue text-sm font-semibold tracking-wide uppercase" data-id="element-102">
          1 Página • 3 Mensajes • 24 Horas
        </motion.div>

        {/* Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-5xl md:text-7xl font-black text-white mb-6 leading-tight tracking-tight" data-id="element-103">
          Tu primer embudo que <br className="hidden md:block" data-id="element-104" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-accent-blue to-white" data-id="element-105">
            sí cobras hoy.
          </span>
        </motion.h1>

        {/* Subtitle */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-xl md:text-2xl text-text-secondary max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-106">
          Un método en español (USA) para vender tu producto digital low ticket
          con 1 página + 3 mensajes, sin embudos gigantes, sin semanas de
          configuración.
        </motion.p>

        {/* Opening Lead */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="max-w-2xl mx-auto mb-12 text-left bg-section/50 p-6 rounded-xl border border-white/5" data-id="element-107">
          <p className="text-text-secondary mb-4" data-id="element-108">
            Hay una razón por la que sientes que trabajas todo el día… y aun así
            no avanzas.
          </p>
          <p className="text-text-secondary mb-4" data-id="element-109">
            No es que seas flojo/a. No es que "no tengas disciplina".
          </p>
          <p className="text-white font-medium" data-id="element-110">
            Es que estás intentando construir un negocio con demasiadas piezas a
            la vez.
          </p>
        </motion.div>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.6
      }} data-id="element-111">
          <Button className="w-full md:w-auto text-xl px-10 py-5" onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-112">
            QUIERO MI EMBUDO EXPRÉS
          </Button>
          <p className="mt-3 text-sm text-text-muted" data-id="element-113">
            Descarga inmediata • Acceso de por vida
          </p>
        </motion.div>

        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="mt-16 relative mx-auto max-w-4xl" data-id="element-114">
          <div className="absolute inset-0 bg-accent-blue/20 blur-[60px] rounded-full transform scale-75" data-id="element-115" />
          <img src="https://cdn.magicpatterns.com/uploads/3gkMifQBZ6VSxPwtSxsRSr/heylloyd-image-1770531244690.png" alt="Embudo Exprés en iPad" className="relative z-10 w-full rounded-2xl shadow-2xl border border-white/10" data-id="element-116" />
        </motion.div>
      </div>
    </header>;
}